import type { CatalogEntry } from './types';
import { RESERVED_CATALOG } from './reserved';
import { AUTH_CATALOG } from './codes/auth';
import { EMAIL_ACCOUNTS_CATALOG } from './codes/email-accounts';
import { DWD_WORKSPACE_CATALOG } from './codes/dwd-workspace';
import { WARMUP_CATALOG } from './codes/warmup';
import { BILLING_CATALOG } from './codes/billing';
import { SETTINGS_CATALOG } from './codes/settings';
import { PROFILE_CATALOG } from './codes/profile';
import { REPORTS_CATALOG } from './codes/reports';
import { ONBOARDING_CATALOG } from './codes/onboarding';
import { NOTIFICATIONS_CATALOG } from './codes/notifications';
import { AI_CATALOG } from './codes/ai';
import { ANALYTICS_CATALOG } from './codes/analytics';
import { HEALTH_CATALOG } from './codes/health';
import { TAGS_CATALOG } from './codes/tags';
import { PREFERENCES_CATALOG } from './codes/preferences';
import { API_CATALOG } from './codes/api';
import { ADMIN_CATALOG } from './codes/admin';
import { INBOUND_WEBHOOKS_CATALOG } from './codes/inbound-webhooks';
import { TEMPLATE_LIBRARY_CATALOG } from './codes/template-library';
import { AUDIT_LOGS_CATALOG } from './codes/audit-logs';
import { SALESHANDY_CATALOG } from './codes/saleshandy';
import { APUS_CATALOG } from './codes/apus';
import { INTERNAL_BACKFILL_CATALOG } from './codes/internal-backfill';
import { ORG_PURGE_CATALOG } from './codes/org-purge';

export type { CatalogEntry };

/**
 * The master error catalog: `code → { httpStatus, message }`.
 * Per-feature catalogs live in `src/codes/<feature>.ts` and are merged here so
 * this file never grows unbounded and parallel feature work never collides.
 */
export const ERROR_CATALOG: Record<string, CatalogEntry> = {
  ...RESERVED_CATALOG,
  ...AUTH_CATALOG,
  ...EMAIL_ACCOUNTS_CATALOG,
  ...DWD_WORKSPACE_CATALOG,
  ...WARMUP_CATALOG,
  ...BILLING_CATALOG,
  ...SETTINGS_CATALOG,
  ...PROFILE_CATALOG,
  ...REPORTS_CATALOG,
  ...ONBOARDING_CATALOG,
  ...NOTIFICATIONS_CATALOG,
  ...AI_CATALOG,
  ...ANALYTICS_CATALOG,
  ...HEALTH_CATALOG,
  ...TAGS_CATALOG,
  ...PREFERENCES_CATALOG,
  ...API_CATALOG,
  ...ADMIN_CATALOG,
  ...INBOUND_WEBHOOKS_CATALOG,
  ...TEMPLATE_LIBRARY_CATALOG,
  ...AUDIT_LOGS_CATALOG,
  ...SALESHANDY_CATALOG,
  ...APUS_CATALOG,
  ...INTERNAL_BACKFILL_CATALOG,
  ...ORG_PURGE_CATALOG,
};
